import { GerenciadorPaginasItens } from "@fl/shared/src/types/menus";
import { UpdatePaginasMenu } from "@fl/shared/src/types/models/suporte_fl/paginas_menus";
import SortFunctions from "./sortArrays";

export const organizeMenus = (
  menus: UpdatePaginasMenu[],
  menusLevel: UpdatePaginasMenu[],
  accumulatedPages: GerenciadorPaginasItens[],
  levelIndex: number
): GerenciadorPaginasItens[] => {
  const resultPages: GerenciadorPaginasItens[] = [...accumulatedPages];

  menusLevel.forEach((item) => {
    const childrens = menus
      .filter((ch) => ch.id_pagina_menu_pai === item.id_pagina_menu)
      .sort((a, b) => new SortFunctions(a.ordem, b.ordem).sortNumberAsc());
    const page: GerenciadorPaginasItens = {
      config: item.config,
      divisor: item.divisor,
      id_pagina_menu: item.id_pagina_menu!,
      id_pagina_menu_pai: item.id_pagina_menu_pai
        ? item.id_pagina_menu_pai
        : null,
      link: item.link ? item.link : "",
      ordem: item.ordem,
      pagina: item.pagina,
      checked: item.checked,
      collapsed: item.collapsed,
      new: item.new,
      edited: item.edited,
      children:
        childrens.length > 0
          ? organizeMenus(menus, childrens, [], levelIndex + 1)
          : [],
    };
    resultPages.push(page);
  });

  return resultPages;
};

export const checKPercurisveMenus = (
  item: GerenciadorPaginasItens[],
  items: UpdatePaginasMenu[],
  checked: boolean
): UpdatePaginasMenu[] => {
  item.map((ch) => {
    const idx = items.findIndex((i) => i.id_pagina_menu === ch.id_pagina_menu);
    items[idx].checked = checked;

    if (ch.children.length > 0) {
      checKPercurisveMenus(ch.children, items, checked);
    } else {
      const index = items.findIndex(
        (it) => it.id_pagina_menu === ch.id_pagina_menu
      );
      items[index].checked = checked;
    }
  });

  return items;
};

export const onCollapseMenus = (
  item: GerenciadorPaginasItens,
  menus: UpdatePaginasMenu[]
): UpdatePaginasMenu[] => {
  var items = [...menus];
  const index = items.findIndex(
    (i) => i.id_pagina_menu === item.id_pagina_menu
  );
  items[index] = { ...item };
  return [...items];
};

export const onCheckMenus = (
  item: GerenciadorPaginasItens,
  menus: UpdatePaginasMenu[]
) => {
  var items = [...menus];
  const index = items.findIndex(
    (i) => i.id_pagina_menu === item.id_pagina_menu
  );
  items[index] = { ...item };

  if (item.children.length > 0) {
    items = checKPercurisveMenus(item.children, items, items[index].checked);
  }
  return [...items];
};

export const collapseAllMenus = (
  menus: UpdatePaginasMenu[],
  collapse: boolean
) => {
  collapse = !collapse;
  const items = [
    ...menus.map((item) => {
      return { ...item, collapsed: collapse };
    }),
  ];

  return { items, collapse };
};

export const checkAllMenus = (menus: UpdatePaginasMenu[], check: boolean) => {
  check = !check;
  const items = [
    ...menus.map((item) => {
      return { ...item, checked: check };
    }),
  ];

  return { items, check };
};

export const checkParentMenus = (menus: UpdatePaginasMenu[]) => {
  const baseMenus = [...menus];
  var filteredMenus = [...menus];

  filteredMenus = filteredMenus.filter(
    (item) => item.checked && (item.id_pagina_menu_pai !== null || undefined)
  );

  const checkParent = (item: UpdatePaginasMenu) => {
    const index = baseMenus.findIndex(
      (m) => m.id_pagina_menu === item.id_pagina_menu
    );
    baseMenus[index].checked = true;

    const parents = menus.filter(
      (ch) => ch.id_pagina_menu === item.id_pagina_menu_pai
    );
    if (parents.length > 0) {
      parents.map((p) => checkParent(p));
    }
  };

  filteredMenus.map((item) => {
    return checkParent(item);
  });

  return [...baseMenus];
};
